<template>
  <v-card id="time-clock" v-if="currentUserCurrentShift">
    <v-container class="pa-3" fluid>
      <v-layout
        class="mb-3 text-xs-center grey lighten-2"
        row
        align-center
        justify-center
        align-content-center
      >
        <v-flex class="mr-1" shrink>
          <v-icon>schedule</v-icon>
        </v-flex>
        <v-flex shrink>
          <h1 class="subtle all-caps">Time Clock</h1>
        </v-flex>
      </v-layout>

      <v-layout row wrap align-center>
        <v-flex xs12 sm3 class="text-xs-center">
          <h2 class="all-caps green--text">Current Shift</h2>
        </v-flex>
        <v-flex xs12 sm5 class="text-xs-center">
          <div>
            <span>
              {{ currentUserCurrentShift.startDatetime | moment("M/D") }} |
              {{ currentUserCurrentShift.startDatetime | moment("h:mma") }} -
              {{ currentUserCurrentShift.endDatetime | moment("h:mma") }}
            </span>
          </div>
          <div>
            <router-link
              :to="{
                name: 'shiftDetail',
                params: { shiftId: currentUserCurrentShift.id },
              }"
            >
              <span class="font-weight-bold">
                {{ currentUserCurrentShift.shiftRole }} |
                {{ currentUserCurrentShift.location }}
              </span>
            </router-link>
          </div>
        </v-flex>
        <v-flex xs12 sm4 class="text-xs-center">
          <v-btn :to="{ name: 'timeclockShiftConfirm' }" color="info">
            <v-icon>timer</v-icon>
            Timeclock
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  created() {
    this.fetchData();
  },
  watch: {
    $route: "fetchData",
  },
  computed: {
    ...mapState("userAuth", ["user"]),
    ...mapState("shifts", ["currentUserCurrentShift"]),
  },
  methods: {
    fetchData() {
      this.$store.dispatch("shifts/getCurrentUserUpcoming").finally(() => {});
    },
  },
};
</script>

<style scoped>
#time-clock {
}
</style>
